import React, { Component } from 'react';
import crop from '../images/leafs.png';
import plot from '../images/smart-farm1.png'
import { toZonedTime, toDate } from 'date-fns-tz';
import { NavLink } from 'react-router-dom';


var cardBtn = {
    'background': 'transparent',
    'border': 'none',
    'cursor': 'pointer',
    'padding': '2px',
    'color': 'inherit'
};



class StationCard extends Component {
    render() {
        const isRTL = this.props.intl?.locale?.startsWith('ar') ?? false;

        return (

            <div className="mdl-cell mdl-cell--8-col">
                <div className="ag-station-card mdl-card mdl-shadow--2dp" dir={isRTL ? 'rtl' : 'ltr'}>
                    <div className="mdl-card__title" title={`${this.props.name} [${this.props.serial}]`}>
                        <h4 className="truncate text-start">
                            {this.props.name} [{this.props.serial}]
                        </h4>
                        <div className="ag-card-menu w-64 truncate justify-end"
                            onClick={() => this.props.viewStation(this.props.serial)}>
                            <a className="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" href="#dummy">
                                {/* {
                  this.props.verified ?
                    <i className="material-icons" style={{ 'color': '#7bd47b' }}>check_circle_outline</i> :
                    <i className="material-icons" style={{ 'color': 'red' }}>error_outline</i>
                } */}
                                <span
                                    dir={isRTL ? 'rtl' : 'ltr'}
                                    title={this.props.intl.formatDate(this.props.last_transmission && toZonedTime(toDate(this.props.last_transmission), this.props.details?.timezone), { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })}
                                > {this.props.intl.formatDate(this.props.last_transmission && toZonedTime(toDate(this.props.last_transmission), this.props.details?.timezone), { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })} </span>
                            </a>
                            <button style={cardBtn} onClick={() => this.props.viewStation(this.props.serial)}><i className="material-icons">more_vert</i></button>

                        </div>

                        {/* <h5> */}
                        {/* {this.props.status} */}
                        {/* </h5> */}
                    </div>


                    <div className="ag-card-text mdl-card__supporting-text !w-full">
                        <div className='flex justify-between flex-row items-end'>
                            <div className="text-start min-w-0">
                                <div className='flex items-center gap-2'><img src={plot} className='inline w-[24px] shrink-0' alt="" /><span className="min-w-0">{this.props.plot}</span></div>
                                <div className='mt-2 flex items-center gap-2'><img src={crop} className='inline w-[24px] shrink-0' alt="" /><span className="min-w-0">{this.props.crop}</span></div>
                            </div>
                            <NavLink
                                to={`/dashboard/${Boolean(this.props.tab_set?.[0]) ? this.props.tab_set?.[0] : this.props.serial}`}
                                state={{
                                    tabName: `${this.props.name} [${this.props.serial}]`,
                                    deviceSerial: this.props.serial,
                                    generateCharts: true
                                }}>
                                <div dir="ltr" className='flex flex-row items-center gap-2 w-[110px] cursor-pointer hover:bg-green-50 rounded-md !h-fit p-1'>
                                    <i className="material-icons shrink-0">bar_chart</i>
                                    <span dir="auto" className='text-sm text-gray-500 text-start'>{this.props.intl.formatMessage({ id: 'app.stations.viewStation.view_data', defaultMessage: 'View Data' })}</span>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default StationCard;